function t(t){const n={};return o=>(void 0===n[o]&&(n[o]=t(o)),n[o])}export{t as default};
//# sourceMappingURL=memoize.js.map
